<template>
  <div class="tg-url-copy">
    <span>{{url}}</span>
    <el-tooltip manual v-model="showLabel" class="item" effect="light" :content="copyed" placement="right" popper-class="tg-url-copy__popper">
      <b @click="copyUrl">{{ $t("btn.copy") }}</b>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLabel: false
    }
  },
  props: {
    url: String
  },
  computed: {
    copyed() {
      return this.$t('label.copyed');
    }
  },
  methods: {
    copyUrl() {
      navigator.clipboard.writeText(this.url).then(() => {
        this.showLabel = true;
        setTimeout(() => {
          this.showLabel = false;
        }, 1000);
      });
    }
  }
};
</script>
